<template>
  <div :class="$style.container" @click="$emit('click')">
    <!-- Заголовок, если нет - Сумма тарифа -->
    <h4
      v-m-b="4"
      :class="$style.title"
      v-text="displayTitle"
    ></h4>

    <!-- Пробный период подписки -->
    <div
      v-if="displayTrialDays"
      v-m-b="4"
      :class="$style.trial"
    >
      <span
        v-m-r="5"
        :class="$style.badge"
        v-text="displayTrialDays"
      ></span>
      <span v-text="`, ${$t('tariff.subscription.trial.days.after')}`"></span>
    </div>

    <div :class="$style.description">
      <!-- Сумма тарифа если есть заголовок -->
      <span
        v-if="tariff.name"
        v-m-r="10"
        v-text="displayAmount"
      ></span>
      <!-- Периодиность списания -->
      <span
        v-if="displayPeriodicity"
        v-color:grey-2
        v-text="displayPeriodicity"
      ></span>
    </div>

    <!-- Описание тарифа -->
    <p
      v-if="tariff.description"
      v-m-t="16"
      :class="$style.description"
      v-text="tariff.description"
    ></p>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

import { PERIODICITY_MAP } from 'definitions/subscription';

export default {
  name: 'SelectableTariff',
  props: {
    tariff: {
      type: Object,
      required: true,
    },
    paymentsEnabled: Boolean,
  },
  computed: {
    displayAmount() {
      const { amount, currency } = this.tariff;

      if (!this.paymentsEnabled) {
        return `XXX ${currency.sign}`;
      }

      if (this.$validate.isNull(amount)) {
        return this.$t('another.sum');
      }

      return formatAmount(amount, currency);
    },
    displayTitle() {
      return this.tariff.name || this.displayAmount;
    },
    displayPeriodicity() {
      const { subscription, arrangement } = this.tariff;

      // Если это счет-билет, то периодичность подписки не отображается
      if (this.$validate.isObject(arrangement)) {
        return null;
      }

      // Если это не счет-подписка
      if (this.$validate.isNotObject(subscription)) {
        return null;
      }

      // Период списания может отсутствовать,
      // если выбран пункт "На выбор подписчиком" или если это установочный платеж
      if (!this.$validate.isObjectWithFields(PERIODICITY_MAP, [subscription.per])) {
        return null;
      }

      return this.$t(PERIODICITY_MAP[subscription.per].description);
    },
    displayTrialDays() {
      const { subscription } = this.tariff;

      if (this.$validate.isNotObject(subscription)) {
        return null;
      }

      if (this.$validate.isNotNumber(subscription.trialDays)) {
        return null;
      }

      return this.$t('tariff.subscription.trial.days', {
        days: this.$tc('pluralize.days', subscription.trialDays),
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative
    padding: 15px
    color: #212121
    background-color: #fff
    border-radius: 5px
    border: 1px solid transparent
    box-shadow: 0px 1px 2px rgba(189, 189, 189, .5)
    transition: all .2s linear

    &:hover
      border-color: rgba(0, 0, 0, .2)
      box-shadow: 0px 4px 4px rgba(189, 189, 189, .75)
      cursor: pointer

  .title
    +font-type(medium, 18, 24)
    word-break: break-word

  .description
    +font-type(regular, 14, 20)
    word-break: break-word

  .trial
    +font-type(regular, 14, 20)
    color: rgba(33, 33, 33, 0.5)

  .badge
    +font-type(medium, 14, 20)
    display: inline-block
    padding: 5px 10px
    color: #212121
    background: linear-gradient(249.76deg, rgba(91, 204, 126, 0.7) -8.32%, rgba(123, 211, 255, 0.7) 108.85%)
    border-radius: 40px
</style>
